import { Component, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router, RouterLink } from '@angular/router';
import { NgbModal, NgbDropdownConfig } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { PrimeNG } from 'primeng/config';

import { v4 as uuidv4 } from 'uuid';
import { ProcesosService } from '../../../services/centralization/procesos.service';
import { CentrosProcesoService } from '../../../services/centralization/centrosProceso.service';
import { EditarConfirmarComponent } from '../../modals/centralizacion-remuneraciones/editar-confirmar/editar-confirmar.component';
import { CalendarModule } from 'primeng/calendar';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-create-special-process',
  imports: [CommonModule, ReactiveFormsModule, CalendarModule],
  templateUrl: './create-special-process.component.html',
  styleUrl: './create-special-process.component.css'
})
export class CreateSpecialProcessComponent {
  proceso: any;
  centrosProceso: any;
  procesoDatosForm: FormGroup;
  centrosSelection: any[] = [];
  centrosSeleccionados: any[] = [];
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  displayedColumns: any[] = [
    'centroCodigoCompania',
    'centroNombre',
    'centroAnalistaFzas',
    'centroPeriodo',
    'centroEstado',
    'centroArchivo',
    'centroSimular',
    'centroProcesar',
    'opciones'
  ];
  pageSize = 5;
  pageSizeOptions = [5, 10, 25, 50];
  totalRows = 0;
  procesoBorradorPaso1: boolean = true;
  procesoBorradorPaso2: boolean = true;
  centroCompletado: boolean = false;
  periodoSelected: string = '';
  UUIDActual: string = '';

  constructor(
    private readonly _formBuilder: FormBuilder,
    private readonly _modalService: NgbModal,
    private readonly _spinner: NgxSpinnerService,
    private readonly _toastr: ToastrService,
    private readonly _router: Router,
    private readonly _primengConfig: PrimeNG,
    private readonly _procesosService: ProcesosService,
    private readonly _centrosProcesoService: CentrosProcesoService,
    config: NgbDropdownConfig
  ) {
    this.procesoDatosForm = this._formBuilder.group({
      procesoNombre: ['', Validators.required],
      procesoPeriodo: ['', Validators.required]
    });
    config.placement = 'bottom-end';
  }

  ngOnInit(): void {
    const data: any[] = [];
    this.dataSource = new MatTableDataSource(data);
    this.totalRows = this.dataSource.data.length;
    this.dataSource.paginator = this.paginator;
    this._primengConfig.setTranslation({
      monthNames: [
        "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
        "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
      ],
      monthNamesShort: [
        "ENE", "FEB", "MAR", "ABR", "MAY", "JUN",
        "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"
      ],
    });
  }

  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    console.log(file);
  }

  onChangeSelectedCentros(event: any, centProcId: any) {
    if (event.target.checked) {
      this.centrosSeleccionados.push({ centProcId: centProcId, selected: true });
      console.log(this.centrosSeleccionados);
    } else {
      const index = this.centrosSeleccionados.findIndex(item => item.centProcId === centProcId);
      if (index > -1) {
        this.centrosSeleccionados.splice(index, 1);
        console.log(this.centrosSeleccionados);
      }
    }
  }

  abrirModalCancelarProceso() {
    const modalRef = this._modalService.open(EditarConfirmarComponent, { backdrop: 'static' });
    modalRef.componentInstance.titulo = 'Cancelar Proceso';
    modalRef.componentInstance.texto = `¿Está seguro de querer cancelar la creación del proceso?`;
    modalRef.result.then(
      (result) => {
        console.log('Modal cerrado con resultado:', result);
        if (result) {
          this._spinner.show();
          this._procesosService.actualizarEstadoProceso(this.proceso.procId, 3).subscribe({
            next: (data: any) => {
              console.log(data);
              this._router.navigate(['/process-list']);
            },
            error: (error: any) => {
              console.log(error);
              this._spinner.hide();
            }
          });
        }
      },
      (reason) => {
        console.log('Modal cerrado por:', reason);
      }
    );
  }

  onChangePeriodo(event: any) {
    console.log(event);
    const date = new Date(event);
    const monthNames = ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    this.periodoSelected = `${month}/${year}`;
    console.log('formattedPeriodo:', this.periodoSelected);
  }

  crearProceso() {

    this.procesoDatosForm.controls['procesoNombre'].setValue(this.procesoDatosForm.controls['procesoNombre'].value.trim());
    if (this.procesoDatosForm.invalid || this.procesoDatosForm.controls['procesoNombre'].value === '') {
      this._toastr.warning('Debes completar todos los campos requeridos', 'Advertencia');
      return;
    }

    this._spinner.show();

    this.UUIDActual = uuidv4();
    let userName = null;
    let userId = null;
    const currentUser = localStorage.getItem('currentUserCr');

    if (currentUser) {
      const parsedUser = JSON.parse(currentUser);
      userName = parsedUser.us_nombres;
      userId = parsedUser.us_id;
      console.log('userName:', userName);
    }

    const newProceso = {
      procNombre: this.procesoDatosForm.controls['procesoNombre'].value,
      procTipo: 'Especial',
      procPeriodo: this.periodoSelected,
      procUUID: this.UUIDActual,
      procUpdateFor: userName,
      procCreateFor: userName,
      userName: userName,
      userId: userId,
    }

    this._procesosService.crearProceso(newProceso).subscribe({
      next: (res: any) => {
        console.log('response:', res);
        this.proceso = res.proceso;
        this.crearCentrosProceso(res.proceso.procId, res.proceso.procNombre);
      },
      error: (err: any) => {
        console.log('error:', err);
        this._spinner.hide();
        this._router.navigate(['process-list']);
        this._toastr.warning('Ocurrio un error al intentar crear un nuevo proceso. Intente más tarde o contacte a Soporte.', 'Error');
      }
    });
  }

  crearCentrosProceso(procId: any, procNombre: any) {
    let userName = null;
    let userId = null;
    const currentUser = localStorage.getItem('currentUserCr');

    if (currentUser) {
      const parsedUser = JSON.parse(currentUser);
      userName = parsedUser.us_nombres;
      userId = parsedUser.us_id;
      console.log('userName:', userName);
    }

    const data = {
      procId: procId,
      procNombre: procNombre,
      procUUID: this.UUIDActual,
      userName: userName,
    }

    this._centrosProcesoService.crearCentrosProceso(data).subscribe({
      next: (res: any) => {
        console.log('response:', res);
        this.centrosSelection = res.centrosProceso;
        this._spinner.hide();
        this.procesoBorradorPaso1 = false;
        this.procesoBorradorPaso2 = false;
        this.procesoDatosForm.controls['procesoNombre'].disable();
        this.procesoDatosForm.controls['procesoPeriodo'].disable();
      },
      error: (err: any) => {
        console.log('error:', err);
        this._spinner.hide();
        this._router.navigate(['process-list']);
        this._toastr.warning('Ocurrio un error al intentar crear un nuevo proceso. Intente más tarde o contacte a Soporte.', 'Error');
      }
    });
  }

  actualizarCentrosProcesoSeleccionados() {
    if (this.centrosSeleccionados.length === 0) {
      this._toastr.warning('Debe seleccionar al menos un centro para continuar.', 'Advertencia');
      return;
    }

    this._spinner.show();
    this._centrosProcesoService.actualizarSeleccionEspecial(this.centrosSeleccionados).subscribe({
      next: (res: any) => {
        console.log('response:', res);
        this._router.navigate(['process/process-detail/', this.proceso.procId, 'Especial']);
      },
      error: (err: any) => {
        console.log('error:', err);
        this._spinner.hide();
        this._router.navigate(['process-list']);
        this._toastr.warning('Ocurrio un error al intentar crear un nuevo proceso. Intente más tarde o contacte a Soporte.', 'Error');
      }
    })
  }

  validarAlfanumerico(event: Event): void {
    const input = event.target as HTMLInputElement;
    let valor = input.value;

    let valorValidado = valor.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚ ]/g, '');

    if (valorValidado.length > 50) {
      valorValidado = valorValidado.substring(0, 50);
    }

    if (valor !== valorValidado) {
      input.value = valorValidado;
      this.procesoDatosForm.controls['procesoNombre'].setValue(valorValidado);
    }
  }
  cancelar(): void {
    this._router.navigate(['process-list']);
  }

}
